import { Flex as ChakraFlex } from "@chakra-ui/react";

/**
 * @typedef {import("@chakra-ui/react").FlexProps} FlexProps
 */

export const Flex = ChakraFlex;
